import crypto from "crypto";
import vm from "@/main";

const db = process.env.VUE_APP_DB || "db";
const k = process.env.VUE_APP_KEY;
const i = process.env.VUE_APP_IV;
const algo = process.env.VUE_APP_ALGO;
const app_name = process.env.VUE_APP_NAME || 'App';

export default {
  async c(a, c) {
    const p = vm === undefined ? {} : vm.$pouch;
    const b = (a.hasOwnProperty('_id'));
    return new Promise(
      async (rs, rj) => {
        if (c) {
          return this.cr(a, b, p, rs, rj);
        } else {
          await this.en(a)
            .then((r) => {
              return this.cr(r, b, p, rs, rj);
            })
            .catch((e) => rj(e))
        }
      }
    );
  },
  async r(a) {
    return new Promise(
      async (rs, rj) =>
        await this.f(a, false, true)
        .then((d) => rs(d))
        .catch((e) => rj(e))
    );
  },
  async u(a) {
    const p = vm === undefined ? {} : vm.$pouch;
    return new Promise(
      async (rs, rj) =>
        await this.en(a)
        .then((r) =>
          p
          .put(r, {}, db)
          .then((f) => rs(f))
          .catch((e) => rj(e))
        )
        .catch((e) => rj(e))
    );
  },
  async d(a) {
    a._deleted = true;
    return new Promise(
      async (rs, rj) =>
        await this.u(a)
        .then((d) => rs(d))
        .catch((e) => rj(e))
    );
  },
  // Methods
  async cr(a, b, p, rs, rj) {
    if (!!b) {
      p.put(a, {}, db)
        .then((f) => {
          rs(f);
        })
        .catch((e) => rj(e));
    } else {
      p.post(a, {}, db)
        .then((f) => {
          rs(f);
        })
        .catch((e) => rj(e));
    }
  },
  async f(a, s, d) {
    const p = vm === undefined ? {} : vm.$pouch;
    return new Promise((rs, rj) => {
      try {
        if (this.io(a) === true || this.ia(a) === true) {
          p
            .find(a, db)
            .then(async (f) => {
              if (f.docs.length > 0) {
                let r = d ? await this.de(f.docs) : f.docs;
                if (s) {
                  return rs(this.ia(r) ? r[0] : r);
                } else {
                  return rs(r);
                }
              } else {
                return rs({
                  x: f.docs,
                  y: f.warning
                });
              }
            })
            .catch((e) => rj(e))
        } else {
          throw "Invalid Data"
        }
      } catch (e) {
        rj(e);
      }
    });
  },
  ia(a) {
    return (!!a) && (a.constructor === Array);
  },
  io(a) {
    return (!!a) && (a.constructor === Object);
  },
  // Hash
  async de(d) {
    const lk = Buffer.from(k, "hex")
    const li = Buffer.from(i, "hex");

    if (this.io(d)) {
      let no = {};
      for (const k in d) {
        if (d.hasOwnProperty(k)) {
          if (k === "_id" || k === "_rev" || k === "_deleted" || k === "y" || k === "z") {
            no[k] = d[k];
          } else {
            try {
              const dec = crypto.createDecipheriv(
                algo,
                lk,
                li
              );
              let dd = Buffer.from(d[k], "hex");
              no[k] = JSON.parse(
                atob(Buffer.concat([dec.update(dd), dec.final()]))
              );
            } catch (e) {
              console.error(`${app_name} Error: `, e)
              no[k] = d[k];
            }
          }
        }
      }
      return no;
    } else if (this.ia(d)) {
      let fa = [];
      for (let i = 0; i < d.length; i++) {
        let no = {};
        for (const k in d[i]) {
          if (d[i].hasOwnProperty(k)) {
            if (k === "_id" || k === "_rev" || k === "_deleted" || k === "y" || k === "z") {
              no[k] = d[i][k];
            } else {
              try {
                const dec = crypto.createDecipheriv(
                  algo,
                  lk,
                  li
                );
                let dd = Buffer.from(d[i][k], "hex");
                no[k] = JSON.parse(
                  atob(Buffer.concat([dec.update(dd), dec.final()]))
                );
              } catch (e) {
                console.error(`${app_name} Error: `, e)
                no[k] = d[i][k];
              }
            }
          }
        }
        fa.push(no);
      }
      return fa;
    }
    return null;
  },
  async en(d) {
    const lk = Buffer.from(k, "hex");
    const li = Buffer.from(i, "hex");
    if (this.io(d)) {
      let no = {};
      for (const k in d) {
        if (d.hasOwnProperty(k)) {
          if (k === "_id" || k === "_rev" || k === "_deleted" || k === "y" || k === "z") {
            no[k] = d[k];
          } else {
            try {
              const cipher = crypto.createCipheriv(
                algo,
                lk,
                li
              );
              no[k] = Buffer.concat([cipher.update(btoa(JSON.stringify(d[k]))), cipher.final()]).toString("hex");
            } catch (e) {
              console.error(`${app_name} Error: `, e)
              no[k] = d[k];
            }
          }
        }
      }
      return no;
    } else if (this.ia(d)) {
      let fa = [];
      for (let i = 0; i < d.length; i++) {
        if (this.io(d[i])) {
          let no = {};
          let od = d[i];
          for (const k in od) {
            if (od.hasOwnProperty(k)) {
              if (k === "_id" || k === "_rev" || k === "_deleted" || k === "y" || k === "z") {
                no[k] = od[k];
              } else {
                try {
                  const cipher = crypto.createCipheriv(
                    algo,
                    lk,
                    li
                  );
                  no[k] = Buffer.concat([
                    cipher.update(btoa(JSON.stringify(od[k]))),
                    cipher.final()
                  ]).toString("hex");
                } catch (e) {
                  console.error(`${app_name} Error: `, e)
                  no[k] = od[k];
                }
              }
            }
          }
          fa.push(no);
        }
      }
      return fa;
    }
    return null;
  },
};